import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { FilterCalendarioSsoModel } from 'src/app/models/calendario-sso/FilterCalendarioSsoModel';
import { UpdateFechaPruebaModel } from 'src/app/models/calendario-sso/UpdateFechaPruebaModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ICalendarioSsoModel } from 'src/app/models/interfaces/calendario-sso/ICalendarioSsoModel';
import { IFilterCalendarioSsoModel } from 'src/app/models/interfaces/calendario-sso/IFilterCalendarioSsoModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { SsoCalendarioRegistrarComponent } from '../sso-calendario-registrar/sso-calendario-registrar.component';
import { CalendarioSsoCreateDefaultModel } from 'src/app/models/calendario-sso/CalendarioSsoCreateDefaultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-sso-calendario-listar',
  templateUrl: './sso-calendario-listar.component.html',
  styleUrls: ['./sso-calendario-listar.component.css']
})
export class SsoCalendarioListarComponent implements OnInit {
  model: IFilterCalendarioSsoModel;
  anioSiguiente: number;
  listaAnios: number[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  fechaPrueba: Date;
  resultsLength = 0;
  currentPage = 0;
  listaCalendario: CalendarioSsoModel[] = new Array<CalendarioSsoModel>();
  currentCalendar: CalendarioSsoModel
  displayedColumns: string[] = [
    'mes',
    'fechaNotificacion',
    'fechaInicio',
    'fechaFin',
    'fechaCierre',
    'acciones'
  ];

  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private storage: StorageService,
    public dialog: MatDialog,
    private alertDialogService: AlertDialogService,
    private confirmDialogService: ConfirmDialogService,
    private service: CalendarioSsoService
  ) {
    this.model = new FilterCalendarioSsoModel();
    this.listaAnios = new Array<number>();
    this.model.pageSize = 30;
    this.currentCalendar = new CalendarioSsoModel();
    this.fechaPrueba = new Date();
    this.anioSiguiente = this.fechaPrueba.getFullYear();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.model.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {

    this.service.getAnios()
      .subscribe((data: number[]) => {
        this.listaAnios = data;
        this.anioSiguiente = this.listaAnios.sort().reverse()[0] + 1;
      });

    this.service.getCurrent(this.model.idCompania)
      .subscribe((data: CalendarioSsoModel) => {
        this.currentCalendar = data;
      });

    this.service.getFechaPrueba()
      .subscribe((data: Date) => {
        this.fechaPrueba = data;
      });
    this.search();
  }

  anioChanged(selectedValue: any) {
    this.search();
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    this.model.pageSize = 30;
    this.service
      .getList(this.model)
      .subscribe((data: CalendarioSsoModel[]) => {
        this.listaCalendario = data;
        // this.resultsLength = data.total;
        // this.currentPage = 0;
        //this.paginator.firstPage();
      });
  }

  updateFechaPrueba() {
    let upd = new UpdateFechaPruebaModel();
    upd.fecha = this.fechaPrueba;
    this.service
      .updateFechaPrueba(upd)
      .subscribe((data: ActionResultModel) => {
        this.alertDialogService.open("Fecha Actualizada");
      });
  }

  generarCalendario() {

    this.confirmDialogService.open(`¿Esta seguro de generar el calendario para el año ${this.anioSiguiente}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {

        let upd = new CalendarioSsoCreateDefaultModel();
        upd.anio = this.anioSiguiente;
        this.service
          .generar(upd)
          .subscribe((result: ActionResultModel) => {
            if (result.type != eTypeResult.SUCCESS) {
              this.alertDialogService.open(result.message);
            } else {
              this.alertDialogService.open(`Se genero el calendario para el año ${this.anioSiguiente}`);
              this.service.getAnios()
                .subscribe((data: number[]) => {
                  this.listaAnios = data;

                  this.anioSiguiente = this.listaAnios.sort().reverse()[0] + 1;
                });
            }
          });
      }
    });
  }

  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    // this.serviceSede
    //   .getListFiltered(this.filter)
    //   .subscribe((data) => {
    //     this.model = data;
    //     this.resultsLength = data.total;
    //   });
  }

  openDialogCalendario(item?: CalendarioSsoModel): void {
    const editData = JSON.parse(JSON.stringify(item));
    editData.comentarioAmpliacion = '';
    // console.log(tipoDocumento);
    const dialogRef = this.dialog.open(SsoCalendarioRegistrarComponent, {
      width: '900px',
      data: editData,
    });

    dialogRef.afterClosed().subscribe((result: CalendarioSsoModel) => {
      // this.animal = result;
      if (result != undefined) {
        this.search();
      }
    });
  }
}